import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'
import get from 'lodash/get'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  authAction,
  positionAction,
  modalAction,
} from './../../actions/'
import {
  authSelector,
  positionSelector,
  modalSelector,
} from './../../selectors'
import { searchPositions } from '../../function'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditPosition from './edit'
import ListPosition from './list'
import PositionForm from '../../components/position'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'

class PositionPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      id: '',
      span: false,
      position: '',
      position_code: '',
      start_date: '',
      search: '',
      defaultPositions: [],
      positions: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.showImport = this.showImport.bind(this)
    this.cancelImport = this.cancelImport.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidMount() {
    this.props.getAuth(localStorage.getItem('access_token'))
  }

  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'positionList') && this.state.search === '') {
      this.setState({
        positions: _.get(nextProps, 'positionList'),
        defaultPositions: _.get(nextProps, 'positionList'),
      })
    }
    if (_.get(nextProps, 'positionCreate.positionCreate')) {
      this.props.showModal(
        'position',
        _.get(nextProps, 'positionCreate.status'),
        _.get(nextProps, 'positionCreate.message')
      )
      this.props.listPosition(localStorage.getItem('access_token'))
      this.props.resetCreatePosition()
    }
    if (_.get(nextProps, 'positionEdit.positionEdit')) {
      this.setState({
        edit: false,
      })
      this.props.showModal(
        'position',
        _.get(nextProps, 'positionEdit.status'),
        _.get(nextProps, 'positionEdit.message')
      )
      if (_.get(nextProps, 'positionEdit.status') === 200) this.showSave()
      this.props.listPosition(localStorage.getItem('access_token'))
      this.props.resetEditPosition()
      this.handleClickEdit(false, '')
    }
    if (_.get(nextProps, 'positionDeactivate.positionDeactivate')) {
      this.props.showConfirm(
        'deletePosition',
        _.get(nextProps, 'positionDeactivate.status'),
        _.get(nextProps, 'positionDeactivate.message')
      )
      this.props.listPosition(localStorage.getItem('access_token'))
      this.props.resetDeactivatePosition()
    }
    if (_.get(nextProps, 'exportURL')) {
      window.open(_.get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportPosition()
    }
    if (_.get(nextProps, 'positionImport')) {
      const import_result = _.get(nextProps, 'positionImport')
      this.showImport(import_result)
      this.props.listPosition(localStorage.getItem('access_token'))
      this.props.resetImportPosition()
    }
  }
  handleClickSearch() {
    this.setState({ positions: _.get(this.state, 'defaultPositions').filter(searchPositions, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ positions: _.get(this.state, 'defaultPositions'), search: '' })
    else this.setState({ search: e.target.value })
  }
  handleClickEdit(editPosition, position_id) {
    this.setState({
      edit: editPosition,
      id: position_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your position information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('positionForm')
  }
  cancelForm() {
    this.props.hideModal('positionForm')
  }
  cancelAlert() {
    this.props.hideModal('position')
  }
  showImport(result) {
    this.props.showConfirm('confirmImport', 'Import Result', result)
  }
  cancelImport() {
    this.props.hideConfirm('confirmImport')
  }
  submitForm() {
    this.props.createPosition(
      {
        position_code: this.state.position_code,
        name: this.state.position,
        start_date: this.state.start_date === '' ? '' : moment(this.state.start_date),
        is_active: this.state.is_active,
      },
      localStorage.getItem('access_token'))
  }

  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectPosition.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectPosition.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    const button = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonOK = (
      <div>
        <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
      </div>
    )
    const buttonClose = (
      <div>
        <NewButton color="info" onClick={ this.cancelImport }>Close</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetching')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          import={ (payload) => this.props.importPosition(payload, localStorage.getItem('access_token')) }
          export={ () => this.props.exportPosition(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          _.get(this.props, 'modalType') === 'position' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ _.get(this.props, 'modalType') === 'position' }
              type={ _.get(this.props, 'modalStatus') }
              message={ _.get(this.props, 'modalMessage') }
            />
        }
        {
          _.get(this.props, 'confirmType') === 'confirmSave' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'confirmSave' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          _.get(this.props, 'confirmType') === 'deletePosition' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'deletePosition' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          _.get(this.props, 'confirmType') === 'confirmImport' &&
          <CustomModalMessage
            hide={ this.cancelImport }
            flag={ 'confirmImport' }
            show={ _.get(this.props, 'confirmType') === 'confirmImport' }
            type={ _.get(this.props, 'confirmStatus') }
            created={ _.get(this.props, 'confirmMessage.createdPositions') }
            updated={ _.get(this.props, 'confirmMessage.updatedPositions') }
            errors={ _.get(this.props, 'confirmMessage.errors') }
            button={ buttonClose }
          />
        }
        <Row noGutters>
          <Col>
            <ListPosition
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              positions={ this.state.positions }
              table={ 7 }
            />
          </Col>
          {
            this.state.span && <Col>
              <EditPosition
                edit={ this.state }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ _.get(this.props, 'confrimType') }
                confirmStatus={ _.get(this.props, 'confirmStatus') }
                confirmType={ _.get(this.props, 'confirmType') }
                confirmMessage={ _.get(this.props, 'confirmMessage') }
              />
            </Col>
          }
        </Row>
        <Modal isOpen={ _.get(this.props, 'modalType') === 'positionForm' } toggle={ this.cancelForm }>
          <PositionForm
            create={ true }
            button={ button }
            confirm={ _.get(this.props, 'modalType') }
            position={ this.state.position }
            position_code={ this.state.position_code }
            start_date={ this.state.start_date }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            handleInput={ this.handleInput }
            cancelForm={ this.cancelForm }
            modalStatus={ _.get(this.props, 'modalStatus') }
            modalType={ _.get(this.props, 'modalType') }
          />
        </Modal>
      </Wrapper>
    )
  }
}

PositionPage.propTypes = {
  createPosition: PropTypes.func.isRequired,
  resetCreatePosition: PropTypes.func.isRequired,
  listPosition: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  resetEditPosition: PropTypes.func.isRequired,
  resetDeactivatePosition: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  redirectAuth: authSelector.redirectAuth,
  redirectPosition: positionSelector.redirectPosition,
  getIsFetching: positionSelector.getIsFetching,
  positionCreate: positionSelector.getCreatePositionData,
  positionEdit: positionSelector.getEditPositionData,
  positionGet: positionSelector.getGetPositionData,
  positionDeactivate: positionSelector.getDeactivatePositionData,
  positionList: positionSelector.getListPosition,
  exportURL: positionSelector.getExportURL,
  positionImport: positionSelector.getImportResult,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  createPosition: positionAction.createPosition,
  resetCreatePosition: positionAction.resetCreatePosition,
  resetEditPosition: positionAction.resetEditPosition,
  resetDeactivatePosition: positionAction.resetDeactivatePosition,
  listPosition: positionAction.getPosition,
  exportPosition: positionAction.exportPosition,
  importPosition: positionAction.importPosition,
  resetExportPosition: positionAction.resetExportPosition,
  resetImportPosition: positionAction.resetImportPosition,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(PositionPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
position: fixed;
top: 0;
left: 0;
bottom: 0;
right: 0;
z-index: 1;
`
const OverlayWrapper = styled.div`
width: 100%;
height: 100%;
position: relative;
`




// WEBPACK FOOTER //
// ./src/pages/position/index.js